import { Navigate, Outlet } from 'react-router-dom';

import { useAuthStore } from '../core';

/** Gate protected routes — redirect to /login when there is no token. */
export const RequireAuth = () => {
  const accessToken = useAuthStore((s) => s.accessToken);
  return accessToken ? <Outlet /> : <Navigate to="/login" replace />;
};
